<template>
    <div class="modal fade" id="detailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document" style="width:90%;max-width:90%;">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title pull-left">Checklist {{ selectedEvents.name }}</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <!-- <button v-if="enableDelete" class="btn btn-danger" @click="deleteEvent(selectedEvent.dds_date)">
                            <i class="fa fa-trash"></i> Deletar
                        </button> -->

                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <div class="info-box p-3 border rounded">
                                    <label class="font-weight-bold text-primary mb-1">Nome do Checklist</label>
                                    <div>{{ selectedEvents.name }}</div>
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <div class="info-box p-3 border rounded">
                                    <label class="font-weight-bold text-primary mb-1">Iniciado por</label>
                                    <div>{{ selectedEvents.starter ? selectedEvents.starter.name : 'Não iniciado' }}</div>
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <div class="info-box p-3 border rounded">
                                    <label class="font-weight-bold text-primary mb-1">Iniciado em</label>
                                    <div>{{ selectedEvents.started_at | brDate }}</div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-4 mb-3">
                                <div class="info-box p-3 border rounded">
                                    <label class="font-weight-bold text-primary mb-1">Finalizado por</label>
                                    <div>{{ selectedEvents.finisher ? selectedEvents.finisher.name : 'Não finalizado' }}</div>
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <div class="info-box p-3 border rounded">
                                    <label class="font-weight-bold text-primary mb-1">Finalizado em</label>
                                    <div>{{ selectedEvents.finished_at | brDate }}</div>
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <div class="info-box p-3 border rounded">
                                    <label class="font-weight-bold text-primary mb-1">Categoria</label>
                                    <div>{{ selectedEvents.category_name }}</div>
                                </div>
                            </div>
                        </div>

                        <hr>
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Descrição</th>
                                    <th>Observação</th>
                                    <th>Status</th>
                                    <th>Ocorrência</th>                                    
                              
                                </tr>
                            </thead>
                            <tbody v-if="selectedEvents">
                                <tr v-for="(item, index) in selectedEvents.items" :key="index">
                                    <td>{{ item.title }}</td>
                                    <td>{{ item.description }}</td>
                                    <td>{{ item.obs }}</td>
                                    <td>{{ item.status }}</td>
                                    <td>
                                        <div v-if="item.nonconformities.length > 0">   
                                            <a class="btn btn-info" v-bind:href="'/nonconformities/view/' + item.nonconformities[0].id">   
                                                <i class="fa fa-eye"></i>
                                            </a>                                            
                                        </div>
                                        
                                    </td>


                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success pull-left" data-dismiss="modal" aria-label="Close">
                        Fechar
                    </button>
                    <!--  <button @click="save" type="button" class="btn" style="background-color: green; color:white"
                        aria-label="Close">
                        Salvar
                    </button>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    props: ["selectedEvents", "selectedEvent", "enableDelete", "themes"],
    methods: {
        save() {
            let successMessageDisplayed = false;


        },
        
        deleteEvent(date) {
            const self = this;
            const api = self.$store.getters.api + "events/delete";

            swal({
                title: "Deseja deletar o registro?",
                text: "Somente será deletado os eventos Programados",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, deletar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger"
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm"
                    }
                }
            })
                .then(value => {
                    switch (value) {
                        case "cancel":
                            swal("Cancelado", "O registro não foi excluido!", "info");
                            break;

                        case "confirm":
                            self.$http
                                .post(api, {
                                    dds_date: date
                                })
                                .then(response => {
                                    self.$message(null, "Eventos deletados com sucesso", "success");
                                })
                                .then(() => {
                                    $("#detailModal").modal("toggle");
                                    self.$emit("deleteEvents");
                                });
                            break;
                    }
                });
        },
        destroy(id, index) {
            const self = this;

            swal({
                title: "Deseja deletar o registro?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, deletar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger"
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm"
                    }
                }
            }).then(value => {
                switch (value) {
                    case "cancel":
                        swal("Cancelado", "O registro não foi excluido!", "info");
                        break;
                    case "confirm":
                        self.$http
                            .delete(self.$store.getters.api + "events/" + id, {
                                id: id
                            })
                            .then(response => {
                                self.selectedEvents.splice(index, 1);
                                this.$parent.getEvents();
                                swal("Sucesso", "Registro excluído com sucesso!", "success");
                            })
                            .catch(errors => {
                                let error = errors.response ? errors.response.data : errors;
                                swal("Erro", error, "error");
                            });
                        break;
                }
            });
        },

    },
    filters: {
        brDate(date) {
            if (date) {
                return (date.substr(8, 2) + "/" + date.substr(5, 2) + "/" + date.substr(0, 4));
            }
            return '';
        }
    }
}
</script>

<style scoped>
.scroll-modal {
    max-height: 480px;
    overflow: overlay;
}

@media screen and (max-width: 767px) {
    .scroll-modal {
        max-height: unset;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckList/DetailModal.vue